// AppLayout.tsx
import { useLocation } from 'react-router-dom';
import Footer from "shared/Footer/Footer";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";


const HIDDEN_LAYOUT_ROUTES = ['/pdf', '/pay-done', '/pay-failed', '/my-bookings'];

const AppLayout = ({ children }: { children: React.ReactNode }) => {

let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }
  const { pathname } = useLocation();
  const hideLayout = HIDDEN_LAYOUT_ROUTES.includes(pathname);

  return (
    <>
      {!hideLayout && <SiteHeader />}
      {children}
      {WIN_WIDTH < 768 && !hideLayout && <FooterNav />}
      {!hideLayout && (
        // The stay-detail page shows a fixed price/Reserve bar below `lg`
        // (MobileFooterSticky). Reserve equal space under the footer so its last
        // line ("© … All rights reserved.") isn't hidden behind that bar.
        <div className={pathname === "/listing-stay-detail" ? "pb-[72px] lg:pb-0 bg-[#faf7f1]" : ""}>
          <Footer />
        </div>
      )}
    </>
  );
};

export default AppLayout;
